import 'react-tooltip/dist/react-tooltip.css';
import './index.css';
import './insights-content.css';

import * as serviceWorker from './serviceWorker';

import { CssBaseline } from '@mui/material';
import { ErrorBoundaryWrapper } from './ErrorBoundaryWrapper';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { RecoilRoot } from 'recoil';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const SessionResetWrapper: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [resetKey, setResetKey] = React.useState(0);

  React.useEffect(() => {
    const handleReset = (event: any) => {
      setResetKey((prev) => prev + 1);
      const targetUrl = event.detail?.targetUrl || '/login';
      if (window.location.pathname !== targetUrl) {
        window.history.replaceState(null, '', targetUrl);
      }
    };
    window.addEventListener('reset-app-state', handleReset as unknown as EventListener);
    return () => window.removeEventListener('reset-app-state', handleReset as unknown as EventListener);
  }, []);

  return (
    <RecoilRoot key={resetKey}>
      <React.StrictMode>
        <ErrorBoundaryWrapper>
          <CssBaseline />
          {children}
        </ErrorBoundaryWrapper>
      </React.StrictMode>
    </RecoilRoot>
  );
};

/**
 * Bootstraps the app. The ChartIQ license key is no longer loaded here; it is
 * fetched lazily from the configuration-provided URL only when a chart mounts
 * (see op-chart-v9/license-loader.ts and chart-widget.tsx), so a key/CDN
 * failure degrades gracefully without blocking app startup.
 */
const startApp = async () => {
  const { App } = await import('./App');
  root.render(
    <React.Fragment>
      <SessionResetWrapper>
        <App />
      </SessionResetWrapper>
    </React.Fragment>,
  );
};

// Start the app bootstrap and show an error if initialization fails.
startApp().catch((error: unknown) => {
  console.error('Failed to initialize the application.', error);
  root.render(<div role="alert">Unable to initialize the application. Please try again later.</div>);
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
